<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
 1 Penn Plaza, Suite 6282<br/>
New York, N.Y. 10019<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © The Estate of William McIlvanney and John Rebus Ltd, 2021<br/>
  Published by arrangement with Canongate Books Ltd, <br/>
  14 High Street, Edinburgh EH1 1TE<br/>
  First publication 2021 by Europa Editions<br/>
<br/>
  The right of Ian Rankin and William McIlvanney to be identified <br/>
as the authors of this work has been asserted by them in accordance <br/>
with the Copyright, Designs and Patents Act 1988.<br/>
<br/>
Every effort has been made to trace copyright holders and obtain <br/>
their permission for the use of copyright material. The publisher apologises <br/>
for any errors or omissions and would be grateful if notified of any corrections <br/>
that should be incorporated in future reprints or editions of this book.<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Cover Art by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
<br/>
  Cover photo © John Cooper / Stockimo / Alamy Stock Photo<br/>
<br/>
  ISBN 9781609457181 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?4f0dfe8c